import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=7c6f61d8&scoped=true"
import script from "./EditModal.vue?vue&type=script&lang=js"
export * from "./EditModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f61d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c6f61d8')) {
      api.createRecord('7c6f61d8', component.options)
    } else {
      api.reload('7c6f61d8', component.options)
    }
    module.hot.accept("./EditModal.vue?vue&type=template&id=7c6f61d8&scoped=true", function () {
      api.rerender('7c6f61d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/QuestionnaireSystem/components/CreateQuesForm/components/EditModal.vue"
export default component.exports